/**
 * Copyright (C) 2020 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import styled from 'styled-components';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
  background-color: rgba(0, 0, 0, 0);
`;

export const StyledToggleButton = styled(ToggleButton)`
  background-color: rgba(0, 0, 0, 0) !important;
  border: none;
  color: rgba(255, 255, 255, 0.3);
  position: absolute;
  padding: 0;

  &.Mui-selected {
    color: rgba(255, 255, 255, 1);
  }
`;

export const ToggleGroupContainer = styled.div`
  position: relative; 
  margin: 5px 0 40px 0;
`;
